import { Injectable } from '@angular/core';
import { FenixClientConfig } from '../models/fenix-client/fenix-client.model';

@Injectable({
  providedIn: 'root'
})
export class FenixClientService {

  chatbot: FenixClient;
  mobileStyle = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    bottom: '0',
    right: '0',
    overflow: 'hidden',
    borderTopRightRadius: '0',
    borderTopLeftRadius: '0',
    backgroundColor: 'white',
    zIndex: '9999'
  };

  constructor() { }

  initializeChatbot(fenixConfig: FenixClientConfig, isMobile?: boolean) {
    this.chatbot = new FenixClient(fenixConfig);

    this.chatbot.headerStyle({
      headerStartColor: '#00554D',
      headerEndColor: '#017761'
    });

    this.chatbot.style(isMobile ? this.mobileStyle : {
      width: '320px',
      height: '520px',
      position: 'fixed',
      bottom: '0',
      right: '10px',
      overflow: 'hidden',
      borderTopRightRadius: '15px',
      borderTopLeftRadius: '15px',
      backgroundColor: 'white',
      boxShadow: '0 0 2px black',
      zIndex: '9999'
    });

    this.chatbot.setActions({ minimize: 'close', close: 'close' });
  }

  get cbChatbotConfig() {
    return {
      enviroment: 'production',
      channel: 'chat',
      creditor: 'S0NlZ0xuYm5SOStoNEVsUGUwT08wZz09',
      queue: 'Z1VCZ3dIOGo0M2Iwc3ZFRklWTWk4dz09',
      subject: 'TmlrRm5iQkNtcE54dU9KeFFNbmN4UT09',
      identifier: 'Client identifier',
      data: { name: 'Cliente' },
    };
  }

  get pfChatbotConfig() {
    return {
      enviroment: 'production',
      channel: 'chat',
      creditor: 'Zm9zaHl3TENydld0cWMxbEdxZHZldz09',
      queue: 'eGRkRG4vMjFnUkV0OTV3emZzR2xjZz09',
      subject: 'V2NLZkNUa2lJZkc4RGRWQ3AxYXFJUT09',
      identifier: 'Client identifier',
      data: { name: 'Cliente' },
    };
  }
}
